import React from 'react';
import PropTypes from 'prop-types';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { getRouterDep } from '@bingads-webui-campaign-react/legacy-router-dep';
import { SharedBudgetEditor } from '../shared-budget-editor';

export class CampaignSharedBudgetEditor extends React.Component {
  static propTypes = {
    scope: PropTypes.instanceOf(QueryParam).isRequired,
    siteMap: siteMapPropType.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    data: PropTypes.shape({
      Amount: PropTypes.number,
    }).isRequired,
    budgetId: PropTypes.number.isRequired,
    updateSharedBudget: PropTypes.func.isRequired,
    campaignId: PropTypes.number.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    summaryBarActivityLogger: PropTypes.shape({
      summaryBarBudgetActivity: PropTypes.any,
    }).isRequired,
    hasBudgetLandscape: PropTypes.bool.isRequired,
  };


  getRouteUrl(routeName, params) {
    const { scope, siteMap } = this.props;

    const { getRouteUrl } = getRouterDep(scope, siteMap);

    return getRouteUrl(routeName, params);
  }

  getBudgetLink(budgetId) {
    return this.getRouteUrl('shared_budget_edit', { budget_id: budgetId });
  }

  getCampaignSettingsLink(campaignId) {
    return this.getRouteUrl('campaign_edit', { campaign_id: campaignId });
  }

  renderBudgetMessage = () => {
    const {
      i18n, budgetId, campaignId,
    } = this.props;
    const budgetLink = this.getBudgetLink(budgetId);
    const campaignSettingsLink = this.getCampaignSettingsLink(campaignId);

    return (
      <div className="shared-budget-edit-budget-message">
        <div className="budget-link">
          <a href={budgetLink}>{i18n.getString(_TL_('Budget settings'))}</a>
          <span>{' '}|{' '}</span>
          <a href={campaignSettingsLink}>{i18n.getString(_TL_('Edit budget type'))}</a>
        </div>
      </div>);
  };

  render() {
    const {
      onSave,
      onCancel,
      data,
      updateSharedBudget,
      summaryBarActivityLogger,
      hasBudgetLandscape,
      scope,
      budgetId,
    } = this.props;

    return (
      <SharedBudgetEditor
        scope={scope}
        data={data}
        budgetId={budgetId}
        onSave={onSave}
        onCancel={onCancel}
        renderCustomContent={this.renderBudgetMessage}
        showBudgetLandscape={hasBudgetLandscape}
        updateSharedBudget={updateSharedBudget}
        summaryBarActivityLogger={summaryBarActivityLogger}
        helpId="pop_BA_CampaignCreate_Budget_SharedBudget"
      />
    );
  }
}
